import { render, staticRenderFns } from "./taskinfo.vue?vue&type=template&id=8f50be32&scoped=true"
import script from "./taskinfo.vue?vue&type=script&lang=js"
export * from "./taskinfo.vue?vue&type=script&lang=js"
import style0 from "./taskinfo.vue?vue&type=style&index=0&id=8f50be32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50be32",
  null
  
)

export default component.exports